<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
        />
      </v-col>
    </v-row>
    <vue-chart type="line" :data="chartData" :options="options"></vue-chart>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'

export default {
  components: {
    RangeFilter,
  },
  name: 'internal-statistic',
  data() {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count of Calls',
                scaleShowLabels: true
              },
              ticks: {
                autoSkip: false,
                display: true,
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Dates'
              },
              ticks: {
                autoSkip: false,
                display: true
              },
              type: 'time',
              distribution: 'series',
              time: {
                unit: 'day',
              }
            }
          ],
        },
      },
      data: [],
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      colors: [
        '#EA6565', '#FF9D9D', '#A75E5E', '#EA704A', '#FBC17D', '#FDED9C', '#43A357',
        '#2AC0AC', '#D5E7B1', '#A1E296', '#B9E7F5', '#398BD8', '#96BCF3', '#8166D0',
        '#9C4B9D', '#B386C5', '#ECD3FF', '#F988D9', '#F86499', '#C264F8'
      ],
    }
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    this.getGoogleApiStats()
  },
  methods: {
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.getGoogleApiStats()
    },
    getGoogleApiStats() {
      axios
          .get(`/stats/ga/${this.dateStart}/${this.dateEnd}`)
          .then(response => {
            this.data = response.data.data
            this.chartData.labels = []
            this.chartData.datasets = []

            for (let d of this.data) {
              if (this.chartData.labels.indexOf(d.date) === -1) {
                this.chartData.labels.push(d.date)
              }
            }
            let groupedData = this._.chain(this.data).groupBy("name").map((value, key) => ({
              label: key,
              datasets: value
            })).value()
            for (let [i, dat] of groupedData.entries()) {
              let graph = {
                label: dat.label,
                data: [],
                borderColor: this.colors[i],
                backgroundColor: 'rgba(0, 0, 0, 0)',
                //borderColor: '#' + Math.floor(Math.random() * 16777215).toString(16),
                borderWidth: 2,
                hoverBorderWidth: 2,
              }

              for (let l of this.chartData.labels) {
                let value = 0
                for (let d of dat.datasets) {
                  if (l === d.date) {
                    value = d.value
                  }
                }

                graph.data.push(value)
              }

              this.chartData.datasets.push(graph)
            }

          })
    },
  }
}

</script>
